/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserVo } from './UserVo';
import {
    UserVoFromJSON,
    UserVoFromJSONTyped,
    UserVoToJSON,
    UserVoToJSONTyped,
} from './UserVo';

/**
 * 
 * @export
 * @interface ResponseListUserVo
 */
export interface ResponseListUserVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListUserVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListUserVo
     */
    message?: string;
    /**
     * 
     * @type {Array<UserVo>}
     * @memberof ResponseListUserVo
     */
    data?: Array<UserVo>;
}

/**
 * Check if a given object implements the ResponseListUserVo interface.
 */
export function instanceOfResponseListUserVo(value: object): value is ResponseListUserVo {
    return true;
}

export function ResponseListUserVoFromJSON(json: any): ResponseListUserVo {
    return ResponseListUserVoFromJSONTyped(json, false);
}

export function ResponseListUserVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListUserVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserVoFromJSON)),
    };
}

export function ResponseListUserVoToJSON(json: any): ResponseListUserVo {
    return ResponseListUserVoToJSONTyped(json, false);
}

export function ResponseListUserVoToJSONTyped(value?: ResponseListUserVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserVoToJSON)),
    };
}

